module.exports = "js/webpack/fefa1a03d92ebad25c88dca94a0b63db.png";